<script setup>
import { onMounted, onUnmounted, reactive, provide, ref} from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import { brandHasCarousel } from '@/Shared/helper-contents.js'
import V2visual from '@/Pages/Brand/V2Components/DetailV2Visual'
import V2intro from '@/Pages/Brand/V2Components/DetailV2Intro'
import V2carousel from '@/Pages/Brand/V2Components/DetailV2Carousel'
import V2video from '@/Pages/Brand/V2Components/DetailV2Video'
import V2news from '@/Pages/Brand/V2Components/DetailV2News'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  brandInfo: Array,
  myNews: Array,
  myCategories: Object,
  myCategoriesColumns: Object,
  pref: Object,
})

provide('data', props.brandInfo[0])

const css = props.brandInfo[0].extra !== null && typeof props.brandInfo[0].extra.brandDetailCSS !== 'undefined' ? `<style>${replaceS3path(stripslashes(props.brandInfo[0].extra.brandDetailCSS))}</style>` : ''
let precss = '<style>'
let postcss = '</style>'
precss += '.brandcolor { color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brandcolorBtn { background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.new-box{ background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += 'a.btn-shop{ background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += 'a.btn-shop.dark{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brand-half-box .title{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brand-products .product-header .product-category .category-list .dropdown li.active a .category-name{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
const customcss = precss + postcss

const filterCategoryByYear = function (year) {
  return props.myCategories[Number(year)].filter((i) => i.visible === 'true' && i.group === 'product')
}

const years = function () {
  return Object.keys(props.myCategories).sort((a, b) => b - a)
}

// const applyGridClass = function (year) {
//   const columnNum = props.myCategoriesColumns[Number(year)]
//   return 'grid grid-cols-2 md:grid-cols-' + columnNum
// }

const pickYear = function (year) {
  currentProducts.focus = Number(year)
  scrollToTarget('.advanced-year-block.focus')
}

const currentProducts = reactive({
  focus: years()[0],
})

const timer = ref(null)
const scrollToTarget = function(element){
  if (typeof window === 'undefined') return
  timer.value = setTimeout(function () {
    const el = document.querySelector(element)
    const top = el.getBoundingClientRect().top 
    const offset = document.querySelector('.header.fixed').clientHeight===0 ? 180 : getOffsetHeight('.header') + 45
    const target = top + window.pageYOffset - offset
    window.scrollTo({
      top: target,
    })
  }, 100)
}

const getOffsetHeight= function(element){
  const el = document.querySelector(element)
  return el.offsetHeight
}

const htmlRef = ref()
onMounted(() => {
  htmlRef.value = document.getElementsByTagName('html')[0]
  htmlRef.value.classList.add(props.brandInfo[0].brandSlug)
})
onUnmounted(() => {
  clearTimeout(timer)
})

</script>

<template>
  <div class="">
    <div id="brandDetail_v2">
      <V2visual />
      <V2intro />

      <template v-if="brandHasCarousel(brandInfo[0])">
        <V2carousel :carousel="brandInfo[0].carousel" />
      </template>

      <template v-if="brandInfo[0].extra.brandDetailHTML2">
        <V2video />
      </template>
      
      <div id="brand-products" class="brand-products pt-12 xs:pt-16 sm:pt-20 md:pt-28 lg:pt-32 scroll-mt-[55px] md:scroll-mt-[75px] xl:scroll-mt-0">
        <div class="contentsContainer 3xl:!max-w-[1200px] 4xl:!max-w-[1400px]">
          <h2 class="lg:block text-[50px] xs:text-[60px] sm:text-[70px] md:text-[80px] lg:text-[80px] mb-10 md:mb-20 font-rift font-bold text-center">
            PRODUCTS
            <small class="font-jpsans block mt-2 sm:mt-3 text-[15px] sm:text-[18px]">商品一覧</small>
          </h2>

          <div v-for="y in years()" :key="y" class="year my-6">
            <div class="product-header product-advance-header relative">
              <h3 :id="'advanced-year-block-' + y" class="product-title advanced advanced-year-block" :class="[{ focus: currentProducts.focus == y }]" @click="pickYear(y)">{{ y }}<span>年モデル</span></h3>
              <template v-if="currentProducts.focus != y">
                <Icon type="arrow" class="absolute right-6 md:right-7 top-0 my-auto bottom-0 z-10 scale-75 rotate-90" />
              </template>
            </div>
            <transition name="fade-in">
              <div v-show="currentProducts.focus == Number(y)" class="product-category product-category-year-">
                <div class="product-category-text">
                  カテゴリーを選んでください
                </div>
                <div class="category-list v3">
                  <div v-for="i in filterCategoryByYear(y)" :key="i" class="each-v3">
                    <Link :href="`/brands/${brandInfo[0].brandSlug}/catalog/${y}/${i.slug}`" class="info">
                      <img :src="i.img" alt="" />
                      <span class="category-name-v3">{{ i.name }}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <V2news :brand-info="brandInfo" :news="myNews" />
    </div>
  </div>

  <div v-html="customcss" />
  <div v-html="css" />
</template>
